<template>
  <div>
    <draggable class="draggable" :list="buttons" handle=".js-draggable-handle" @change="handleUpdate">
      <div class="draggable__item" v-for="(button, index) in buttons" :key="index">
        <div class="d-flex align-items-center pr-2">
          <i class="fas fa-ellipsis-v draggable__handle js-draggable-handle"></i>
        </div>

        <div class="col px-1">
          <div class="custom-control custom-checkbox mb-2">
            <input
              class="custom-control-input"
              type="checkbox"
              name="new_tab"
              :id="`button-newtab-${id}-${index}`"
              v-model="button.new_tab"
              @change="handleUpdate"
            />
            <label :for="`button-newtab-${id}-${index}`" class="custom-control-label">
              Openen in nieuw tabblad
            </label>
          </div>

          <input
            class="form-control"
            type="text"
            name="text"
            v-model="button.text"
            @keyup="handleUpdate"
            placeholder="Tekst"
          />
        </div>

        <div class="col px-1">
          <div class="custom-control custom-checkbox mb-2">
            <input
              class="custom-control-input"
              type="checkbox"
              name="new_tab"
              :id="`button-external-${id}-${index}`"
              v-model="button.external"
              @change="handleUpdate"
            />
            <label :for="`button-external-${id}-${index}`" class="custom-control-label">
              Externe link
            </label>
          </div>

          <input
            class="form-control"
            type="text"
            name="url"
            v-model="button.url"
            @keyup="handleUpdate"
            placeholder="URL"
          />
        </div>

        <button class="btn btn-danger ml-2 align-self-end" @click="removeField(index)" type="button">
          <i class="fas fa-times"></i>
          <span class="sr-only">Verwijder knop</span>
        </button>
      </div>
    </draggable>

    <button
      class="btn btn-secondary"
      @click="addField"
      type="button"
      :disabled="buttons.length === 2"
    >
      Knop toevoegen
    </button>
  </div>
</template>

<script>
  import draggable from 'vuedraggable';

  export default {
    components: { draggable },
    props: ['id', 'field'],

    data() {
      return {
        buttons: null,
      };
    },

    created() {
      this.buttons = Array.prototype.slice.call(this.field.specification.buttons);

      if (typeof this.field.value !== 'undefined' && this.field.value) {
        this.field.value.forEach((button) => {
          this.buttons.push(button);
        });
      }
    },

    methods: {
      addField() {
        this.buttons.push({
          text: '',
          url: '',
          external: false,
          new_tab: false,
        });
      },

      removeField(index) {
        this.$delete(this.buttons, index);
        this.handleUpdate();
      },

      handleUpdate() {
        this.$emit('field-update', this.field.key, this.buttons);
      }
    }
  };
</script>
